import * as React from "react";
import EdButton from "../../../../generic/edButton";
import ObAssetsDetlMob from "../../instruments/details/obAssetsDetlMob";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetailsMob.scss";
import { ObAssetsDetlProps } from "./../../instruments/details/obAssetsDetl";
import moment from "moment";
import ObMfSiphisDtlContent from "../dsk/obMfSipDtlContent";
import { ChipStatusComb } from "../../obConstants";

export interface IObMfSipDtlMobProps {
	data: any;
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ObMfSipDtlMob: React.FC<IObMfSipDtlMobProps> = (props) => {
	const backButtonValue = (
		<>
			<i className="arrow_left edel-icon-arrow-left vTextTop" />
			<span>Back</span>
		</>
	);

	const assetDetail: ObAssetsDetlProps = {
		date: props.data.txnDate ? moment(new Date(props.data.txnDate)).format("D MMM YYYY, HH:mm:ss") : "",
		trsTyp: "BUY",
		title: props.data.schemeName,
		sts: ChipStatusComb[props.data.status.toLowerCase()]
	};

	return (
		<section className="ob_detail_container">
			<section className="ob_detail_wrapper">
				<section className="ob_holdings_mob">
					<div className="ob_mob ly_mob ">
						<div className="ob_title ly_title  bckBtnDiv">
							<EdButton value={backButtonValue} btnTyp="link" onClick={props.onBackClick} className="icon_button" />
						</div>
						<div className="lv_header">
							<ObAssetsDetlMob {...assetDetail} />
						</div>
						<div className="ob_content_mob ly_content_mob ">
							{/* detailed content */}
							<ObMfSiphisDtlContent data={props.data} onCancelClick={props.onCancelClick} />
						</div>
					</div>
				</section>
			</section>
		</section>
	);
};

export default ObMfSipDtlMob;
